import { defaultFaqEntries } from "./data/faq/defaultFaq";
import { partnersFaqEntries } from "./data/faq/partnersFaq";
import {
  HOME_PAGE_META,
  BILL_SAVINGS_VIDEO_LANDING_META,
  PARTNERS_PAGE_META,
  PAID_MEDIA_LANDING_META,
  PROGRESSIVE_REGISTRATION_LANDING_META,
  REGISTER_PAGE_META,
  SALES_PARTNER_REGISTER_META,
  REFERRAL_PAGE_META,
  STATE_LANDING_PAGES,
  getGlossaryIndexSeo,
  getGlossaryTermSeo,
  getStateLandingSeo,
} from "./seo/indexablePages";
import { getGlossaryTerms } from "./data/glossaryTerms";

const createPublicRoute = (config) => Object.assign({}, config);

export const STATIC_PUBLIC_ROUTES = [
  createPublicRoute({
    key: "home",
    path: "/",
    changefreq: "weekly",
    priority: "1.0",
    seo: HOME_PAGE_META,
    prerenderKind: "home",
    faqEntries: defaultFaqEntries,
  }),
  createPublicRoute({
    key: "register",
    path: "/register",
    changefreq: "weekly",
    priority: "0.9",
    seo: REGISTER_PAGE_META,
    prerenderKind: "register",
  }),
  createPublicRoute({
    key: "partners",
    path: "/parceiros",
    changefreq: "weekly",
    priority: "0.8",
    seo: PARTNERS_PAGE_META,
    prerenderKind: "partners",
    faqEntries: partnersFaqEntries,
  }),
  createPublicRoute({
    key: "referral",
    path: "/indicacao",
    changefreq: "weekly",
    priority: "0.8",
    seo: REFERRAL_PAGE_META,
    prerenderKind: "referral",
  }),
  createPublicRoute({
    key: "sales_partner_register",
    path: "/cadastro-parceiro",
    changefreq: "weekly",
    priority: "0.8",
    seo: SALES_PARTNER_REGISTER_META,
    prerenderKind: "sales-partner-register",
  }),
  createPublicRoute({
    key: "energia_por_assinatura",
    path: "/energia-por-assinatura",
    changefreq: "weekly",
    priority: "0.9",
    seo: PAID_MEDIA_LANDING_META,
    prerenderKind: "paid-media-landing",
  }),
  createPublicRoute({
    key: "cadastro_energia_por_assinatura",
    path: "/cadastro-energia-por-assinatura",
    changefreq: "weekly",
    priority: "0.8",
    seo: PROGRESSIVE_REGISTRATION_LANDING_META,
    prerenderKind: "paid-media-landing",
  }),
  createPublicRoute({
    key: "economia_na_conta_de_luz",
    path: "/economia-na-conta-de-luz",
    changefreq: "weekly",
    priority: "0.9",
    seo: BILL_SAVINGS_VIDEO_LANDING_META,
    prerenderKind: "paid-media-landing",
  }),
].concat(
  STATE_LANDING_PAGES.map((page) =>
    createPublicRoute({
      key: page.path.replace(/^\//, "").replace(/\//g, "_"),
      path: page.path,
      changefreq: "weekly",
      priority: "0.9",
      seo: getStateLandingSeo(page),
      prerenderKind: "state-landing",
      stateLandingPage: page,
    })
  )
);

export const GLOSSARY_INDEX_ROUTE = createPublicRoute({
  key: "glossary_index",
  path: "/glossario",
  changefreq: "monthly",
  priority: "0.8",
  prerenderKind: "glossary-index",
});

export const GLOSSARY_TERM_PATH = "/glossario/:slug";
export const DIRECT_LOAD_SPA_ROUTE_PATTERNS = [
  "/auth/callback",
  "/login",
  "/dashboard",
  "/settings",
  "/settings/**",
  "/download=*",
  "/signtoa=*",
  "/signpa=*",
];

export const STATIC_PUBLIC_ROUTES_BY_KEY = STATIC_PUBLIC_ROUTES.reduce(
  (acc, route) => {
    acc[route.key] = route;
    return acc;
  },
  {}
);

export const getGlossaryIndexRoute = () =>
  createPublicRoute(
    (() => {
      const glossaryTerms = getGlossaryTerms();

      return Object.assign({}, GLOSSARY_INDEX_ROUTE, {
        seo: getGlossaryIndexSeo(glossaryTerms),
        glossaryTerms,
      });
    })()
  );

export const getGlossaryTermRoutes = () =>
  getGlossaryTerms().map((term) =>
    createPublicRoute({
      key: `glossary_${term.slug}`,
      path: `/glossario/${term.slug}`,
      changefreq: "monthly",
      priority: "0.6",
      seo: getGlossaryTermSeo(term),
      prerenderKind: "glossary-term",
      glossaryTerm: term,
    })
  );

export const getAllIndexableRoutes = () =>
  STATIC_PUBLIC_ROUTES.concat(
    [getGlossaryIndexRoute()],
    getGlossaryTermRoutes()
  );
